module.exports = __webpack_public_path__ + "img/v5.fa701ae4.png";